import { SdkState } from './types';
import { RootState } from 'store/reducer';
import { createSelector } from 'reselect';

export const sdkSelector = (state: RootState): SdkState => state.sdk;

export const selectAvailableCmds = createSelector([sdkSelector], sdk => sdk.availableCmds);

export const selectIsNativeHeaderHidden = createSelector([sdkSelector], sdk => Boolean(sdk?.isNativeHeaderHidden));
